import React from 'react';
import type { ReactNode } from 'react';
import { Alert } from '@mui/material';
import combineStyles from 'classnames';
import { makeStyles } from '~/tools/makeStyles';

type Severity = 'error' | 'warning';

// MUI builds its `filled` variant only for palette colors that define `dark`, and neither `error`
// nor `warning` does, so the background comes from here. `warning.main` is a pale yellow that white
// text cannot sit on, hence `secondaryaccent` for the warning fill.
const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    '& .MuiAlert-icon': {
      color: theme.palette.common.white,
    },
  },
  error: {
    backgroundColor: theme.palette.error.main,
  },
  warning: {
    backgroundColor: theme.palette.secondaryaccent,
  },
}));

type StatusAlertProps = {
  severity: Severity;
  className?: string;
  children: ReactNode;
};

export const StatusAlert = ({ severity, className, children }: StatusAlertProps) => {
  const styles = useStyles();

  return (
    <Alert severity={severity} variant="filled" className={combineStyles(styles.root, styles[severity], className)}>
      {children}
    </Alert>
  );
};
